import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import Divider from "../../../Divider";
const DropdownFooter = ({ children }) => (_jsxs("div", { className: "flex flex-col gap-2.5", children: [_jsx(Divider, {}), children] }));
export default memo(DropdownFooter);
